"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialSection = exports.LinkGrouping = exports.LegalSection = exports.ContactSection = void 0;

var _react = _interopRequireDefault(require("react"));

var _svg = _interopRequireDefault(require("../svg"));

var _sections = require("../contentful-views/sections");

var _visuallyHidden = _interopRequireDefault(require("../visually-hidden"));

var _footer = require("./footer.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function showOsanoDrawer(e) {
  var _Osano, _Osano$cm;

  e.preventDefault();
  (_Osano = Osano) === null || _Osano === void 0 ? void 0 : (_Osano$cm = _Osano.cm) === null || _Osano$cm === void 0 ? void 0 : _Osano$cm.showDrawer('osano-cm-dom-info-dialog-open');
}

var LinkGrouping = function LinkGrouping(_ref) {
  var content = _ref.content;
  return (content === null || content === void 0 ? void 0 : content.map(function (group, index) {
    return /*#__PURE__*/_react["default"].createElement(_footer.Grouping, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_footer.SectionHeader, null, group.title), /*#__PURE__*/_react["default"].createElement(_footer.LinkList, {
      "aria-labelledby": "".concat(group.title, "-footer-menu")
    }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden["default"], {
      id: "".concat(group.title, "-footer-menu")
    }, group.title, " links"), (0, _sections.getSectionsArray)(group.items)));
  })) || null;
};

exports.LinkGrouping = LinkGrouping;

var ContactSection = function ContactSection(_ref2) {
  var content = _ref2.content;
  return /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement(_footer.SectionHeader, null, content === null || content === void 0 ? void 0 : content.title), /*#__PURE__*/_react["default"].createElement(_footer.LinkList, {
    as: "div"
  }, (0, _sections.getSectionsArray)(content === null || content === void 0 ? void 0 : content.listItems)));
};

exports.ContactSection = ContactSection;

var SocialIcon = function SocialIcon(_ref3) {
  var _icon$fields;

  var icon = _ref3.icon;
  if (!icon) return null;
  var svgAsset = icon === null || icon === void 0 ? void 0 : (_icon$fields = icon.fields) === null || _icon$fields === void 0 ? void 0 : _icon$fields.svgAsset;
  if (!svgAsset) return null;
  return /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    svgAsset: svgAsset
  });
};

var SocialSection = function SocialSection(_ref4) {
  var _content$listItems, _content$listItems2;

  var content = _ref4.content;
  return /*#__PURE__*/_react["default"].createElement(_footer.SocialWrapper, null, /*#__PURE__*/_react["default"].createElement("nav", {
    "aria-labelledby": "".concat(content === null || content === void 0 ? void 0 : content.title, "-section")
  }, /*#__PURE__*/_react["default"].createElement(_footer.SectionHeader, {
    id: "".concat(content === null || content === void 0 ? void 0 : content.title, "-section")
  }, content === null || content === void 0 ? void 0 : content.title), /*#__PURE__*/_react["default"].createElement(_footer.SocialIconWrapper, {
    iconCount: content === null || content === void 0 ? void 0 : (_content$listItems = content.listItems) === null || _content$listItems === void 0 ? void 0 : _content$listItems.length
  }, (content === null || content === void 0 ? void 0 : (_content$listItems2 = content.listItems) === null || _content$listItems2 === void 0 ? void 0 : _content$listItems2.map(function (link) {
    var _link$fields, _link$fields2, _link$fields3, _link$fields4, _link$fields5, _link$fields6, _link$fields7, _link$fields8;

    return /*#__PURE__*/_react["default"].createElement(_footer.SocialLink, {
      key: link === null || link === void 0 ? void 0 : (_link$fields = link.fields) === null || _link$fields === void 0 ? void 0 : _link$fields.id,
      className: "social-item-link",
      href: link === null || link === void 0 ? void 0 : (_link$fields2 = link.fields) === null || _link$fields2 === void 0 ? void 0 : _link$fields2.url,
      target: link === null || link === void 0 ? void 0 : (_link$fields3 = link.fields) === null || _link$fields3 === void 0 ? void 0 : _link$fields3.target,
      rel: link === null || link === void 0 ? void 0 : (_link$fields4 = link.fields) === null || _link$fields4 === void 0 ? void 0 : _link$fields4.rel,
      "aria-label": "External link to Glowforge's ".concat(link === null || link === void 0 ? void 0 : (_link$fields5 = link.fields) === null || _link$fields5 === void 0 ? void 0 : _link$fields5.text, " page"),
      icon: /*#__PURE__*/_react["default"].createElement(SocialIcon, {
        icon: link === null || link === void 0 ? void 0 : (_link$fields6 = link.fields) === null || _link$fields6 === void 0 ? void 0 : _link$fields6.icon
      })
    }, !(link !== null && link !== void 0 && (_link$fields7 = link.fields) !== null && _link$fields7 !== void 0 && _link$fields7.icon) ? link === null || link === void 0 ? void 0 : (_link$fields8 = link.fields) === null || _link$fields8 === void 0 ? void 0 : _link$fields8.text : null);
  })) || null)));
};

exports.SocialSection = SocialSection;

var LegalSection = function LegalSection(_ref5) {
  var _content$listItems3, _content$listItems4;

  var content = _ref5.content;
  var privacyPreferencesId = "footer-legal-link-privacy-preferences";
  return /*#__PURE__*/_react["default"].createElement(_footer.CopyRightRow, null, /*#__PURE__*/_react["default"].createElement(_footer.CopyRightTitle, {
    source: content === null || content === void 0 ? void 0 : content.title
  }), /*#__PURE__*/_react["default"].createElement(_footer.LegalLinkSection, {
    linkCount: content === null || content === void 0 ? void 0 : (_content$listItems3 = content.listItems) === null || _content$listItems3 === void 0 ? void 0 : _content$listItems3.length,
    "aria-labelledby": "footer-legal-links-section"
  }, (content === null || content === void 0 ? void 0 : (_content$listItems4 = content.listItems) === null || _content$listItems4 === void 0 ? void 0 : _content$listItems4.map(function (link, index) {
    var _link$fields9, _link$fields10, _link$fields11, _link$fields12, _link$fields13, _link$fields14, _link$fields15, _content$listItems5;

    return /*#__PURE__*/_react["default"].createElement(_footer.LegalLinkWrapper, {
      key: link === null || link === void 0 ? void 0 : (_link$fields9 = link.fields) === null || _link$fields9 === void 0 ? void 0 : _link$fields9.id
    }, (link === null || link === void 0 ? void 0 : (_link$fields10 = link.fields) === null || _link$fields10 === void 0 ? void 0 : _link$fields10.id) == privacyPreferencesId ? /*#__PURE__*/_react["default"].createElement(_footer.LegalLink, {
      href: "",
      onClick: showOsanoDrawer,
      variant: "legal"
    }, link === null || link === void 0 ? void 0 : (_link$fields11 = link.fields) === null || _link$fields11 === void 0 ? void 0 : _link$fields11.text) : /*#__PURE__*/_react["default"].createElement(_footer.LegalLink, {
      href: link === null || link === void 0 ? void 0 : (_link$fields12 = link.fields) === null || _link$fields12 === void 0 ? void 0 : _link$fields12.url,
      rel: link === null || link === void 0 ? void 0 : (_link$fields13 = link.fields) === null || _link$fields13 === void 0 ? void 0 : _link$fields13.rel,
      target: link === null || link === void 0 ? void 0 : (_link$fields14 = link.fields) === null || _link$fields14 === void 0 ? void 0 : _link$fields14.target,
      variant: "legal"
    }, link === null || link === void 0 ? void 0 : (_link$fields15 = link.fields) === null || _link$fields15 === void 0 ? void 0 : _link$fields15.text), index !== (content === null || content === void 0 ? void 0 : (_content$listItems5 = content.listItems) === null || _content$listItems5 === void 0 ? void 0 : _content$listItems5.length) - 1 ? /*#__PURE__*/_react["default"].createElement(_footer.Divider, null) : null);
  })) || null, /*#__PURE__*/_react["default"].createElement(_visuallyHidden["default"], {
    id: "footer-legal-links-section"
  }, "Legal Links")));
};

exports.LegalSection = LegalSection;